/// <reference path="../../../../../../typings/index.d.ts" />


// Used as an attribute on inputs so that when enter is hit soft keyboards on phones and tablets will disappear
module Meevo.Components.Controls.HideInput {


    import CultureSettings = Meevo.Components.Common.CultureSettings;
    import ICultureModel = Meevo.Components.Common.ICultureModel;

    class CountrySelectorComponent implements angular.IComponentController {
        static $inject = [
            '$scope',
            'meevo.AppSettings'
        ];

        private model: angular.INgModelController;

        cultureSettings: ICultureModel[];
        selectedCulture: ICultureModel;

        constructor(protected scope: ng.IScope,
                    protected appSettings: Meevo.Components.Common.IAppSettings) {
            this.cultureSettings = CultureSettings.cultureModelsList(['us', 'gb', 'ca']);
        }

        $onInit() {
            this.scope.$watch(() => this.selectedCulture, (newValue) => {
                this.model.$setViewValue(newValue);
            });

            this.selectedCulture = CultureSettings.getByProperty('locale', this.appSettings.APP_COUNTRYID);
        }

        selectedValueView() {
            return `
              <div class="selected-flag" tabindex="-1" title="${this.selectedCulture.name}: +${this.selectedCulture.countryCode}">
                <div class="iti-flag ${this.selectedCulture.isoCountryCode.toLowerCase()}"></div>
                <div class="iti-arrow"></div>
              </div>
            `;
        }
    }

    angular
        .module('meevo.components.controls.HideInput')
        .component('countrySelector', <ng.IComponentOptions>{
            template:
                `
      <md-select ng-model="$ctrl.selectedCulture" md-selected-html="$ctrl.selectedValueView() | trust" ng-model-options="{trackBy: '$value.isoCountryCode'}">
        <md-option ng-value="culture" ng-repeat="culture in $ctrl.cultureSettings">
          <div class="flag-box">
              <div class="iti-flag" ng-class="['iti-flag', culture.isoCountryCode.toLowerCase()]"></div>
          </div>
          <span class="country-name">{{::culture.name}}</span>
          <span class="dial-code">+{{::culture.countryCode}}</span>
        </md-option>
      </md-select>
      `,
            require: {
                model: '^ngModel'
            },
            controller: CountrySelectorComponent
        });
}
